export const IdentityEnum = {
  CARRIER: 'CARRIER',
  DRIVER: 'DRIVER'
};
